// „Szybkie zestawy" na stronie Pakiety sprzętu — czysty moduł (bez Reacta i axiosa).
//
// 2026-09-17: podpowiedzi pochodzą z HISTORII rezerwacji (GET /api/bundle-suggestions,
// Login/backend/lib/bundleSuggestions.js) — zestawy typów, które klienci firmy faktycznie
// wypożyczają razem. Wcześniej była tu lista na sztywno („Narty + buty", „Deska + buty")
// dopasowywana po fragmentach nazw typów, więc wypożyczalnia rowerów, kajaków czy namiotów
// nie dostawała ani jednej podpowiedzi. Teraz działa to w każdej branży i dla nazw typów
// dodanych przez firmę.
//
// Cena sugerowana jak dotąd: round(suma avgPrice typów × 0.9); avgPrice z GET /api/types.

const DISCOUNT_FACTOR = 0.9;

const sameSet = (a, b) => a.length === b.length && a.every((x) => b.includes(x));

// suggestions: [{ typeIds, times }] z GET /api/bundle-suggestions (już posortowane: najczęstsze).
// types: [{ id, name, avgPrice }] z GET /api/types.
// bundles: istniejące zestawy [{ typeIds }] — podpowiedź identyczna z istniejącym zestawem znika.
// Podpowiedź z typem, którego firma już nie ma (usunięty sprzęt), też znika.
export function buildBundlePresets({ suggestions, types, bundles } = {}) {
  const typeList = Array.isArray(types) ? types : [];
  const byId = new Map(typeList.map((tp) => [Number(tp.id), tp]));
  const existing = (Array.isArray(bundles) ? bundles : [])
    .map((b) => (Array.isArray(b.typeIds) ? b.typeIds.map(Number) : []))
    .filter((ids) => ids.length > 0);

  const presets = [];
  for (const s of Array.isArray(suggestions) ? suggestions : []) {
    const ids = (Array.isArray(s.typeIds) ? s.typeIds : []).map(Number);
    if (ids.length < 2) continue;
    const matched = ids.map((id) => byId.get(id));
    if (matched.some((tp) => !tp)) continue;
    if (existing.some((set) => sameSet(set, ids))) continue;

    const prices = matched.map((tp) => (tp.avgPrice != null ? Number(tp.avgPrice) : null));
    const hasAllPrices = prices.every((p) => p != null && Number.isFinite(p));
    const rawSum = hasAllPrices ? prices.reduce((sum, p) => sum + p, 0) : null;
    const suggestedPrice = hasAllPrices ? Math.round(rawSum * DISCOUNT_FACTOR) : null;
    const sumIndividual = hasAllPrices ? Math.round(rawSum) : null;
    const discountPct = hasAllPrices && rawSum > 0
      ? Math.round((1 - suggestedPrice / rawSum) * 100)
      : null;

    presets.push({
      key: `types-${ids.join('-')}`,
      // Nazwa trafia do bazy jako nazwa zestawu, więc to surowe nazwy typów (dane), nie tłumaczenia.
      name: matched.map((tp) => tp.name).join(' + '),
      typeIds: ids,
      typeNames: matched.map((tp) => tp.name),
      times: Number(s.times) || 0,
      suggestedPrice,
      sumIndividual,
      discountPct,
    });
  }
  return presets;
}
